import { createAppInstance } from "../src/decision_tree_viewer";

let app;

document.addEventListener("DOMContentLoaded", () => {
  const detail = { selector: "#decision-tree-viewer" };
  const event = new CustomEvent("decision-tree-viewer:mount", { detail });
  document.dispatchEvent(event);
});

document.addEventListener("decision-tree-viewer:mount", async (event) => {
  const { selector, props } = event.detail;
  const container = document.querySelector(selector);

  if (container) {
    app = await createAppInstance(props ?? JSON.parse(container.dataset.vueProps));
    app.mount(container);
  }
});

document.addEventListener("decision-tree:allow-booking", () => {
  app.unmount();
  app = null;
});
